import { useState, useContext, useEffect, useMemo } from "react";
import { Col, Form, Row, Table } from "react-bootstrap";
import { AuthContext } from "../contexts/AuthContext";
import { PageContext, PAGE_OWN } from "../contexts/PageContext";
import { SettingContext } from "../contexts/SettingContext";
import { DATATYPE_DOSE, DATATYPE_SYSTEM, TITLE } from "../databases/spName";
import { UpdateSettingDisabledHidden } from "../databases/locks";
import BlockContainer from "../components/BlockContainer";
import { SelectForm } from "../components/FormItem";



const PageLocks = () => {

    const [round, setRound] = useState(0);
    const { disabledHiddenList } = useContext(SettingContext)
    const { managerRound, userRole } = useContext(AuthContext)
    const { setPage } = useContext(PageContext)

    const EnabledField = useMemo(() => {
        return [...Object.keys(TITLE).filter(v => ![DATATYPE_SYSTEM, DATATYPE_DOSE].includes(TITLE[v].datatype) && !['round', 'email'].includes(v))]
    }, [])


    useEffect(() => {
        return () => {
            setRound(0)
        }
    }, [])

    useEffect(() => {
        if (!userRole) {
            setPage(PAGE_OWN)
        }
        else if (userRole === 1 && !isNaN(managerRound)) {
            setRound(managerRound)
        }
    }, [userRole, managerRound, setPage])

    
    return (
        <div>
            <div className="bold">ตั้งค่า</div>
            <BlockContainer>
                <Row bsPrefix="row align-items-center" hidden={userRole <= 1}>
                    <Col bsPrefix='col-auto'><span>เลือกเที่ยวบิน : </span></Col>
                    <Col bsPrefix='col-auto'><SelectForm noMargin={true} value={round} onChange={e => setRound(e.target.value)} options={TITLE.round.options} /></Col>
                </Row>
                <br />
                
                <Table responsive striped bordered hover>
                    <thead><tr>
                        <th></th>
                        <th>ปิดการแก้ไข</th>
                        <th>ปิดการมองเห็น</th>
                    </tr></thead>

                    {[...Object.keys(TITLE.round.options)].map(r => (
                        <tbody key={r}>
                            {EnabledField.map((field, index) => (
                                <tr key={index} hidden={String(r) !== String(round)}>
                                    <td style={{paddingBlock : '2px'}} >{TITLE[field].TH} / {TITLE[field].CN}</td>
                                    <td style={{paddingBlock : '2px'}} >
                                        {disabledHiddenList[r] && disabledHiddenList[r][field] ? <Form.Check checked={disabledHiddenList[r] ? disabledHiddenList[r][field].disabled : false} onChange={e => UpdateSettingDisabledHidden(e.target.checked, r, field, 'disabled')} /> : <></>}
                                    </td>
                                    <td style={{paddingBlock : '2px'}} >
                                        {disabledHiddenList[r] && disabledHiddenList[r][field] ? <Form.Check checked={disabledHiddenList[r] ? disabledHiddenList[r][field].hidden : false} onChange={e => UpdateSettingDisabledHidden(e.target.checked, r, field, 'hidden')} /> : <></>}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                            ))}
                    
                </Table>
            </BlockContainer>
        </div>
    )
}

export default PageLocks;